"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exerciseCallbacksPropTypes = exports.campusCallbacksPropTypes = exports.exercisePropTypes = exports.ResourceTypes = exports.ExerciseEnvironment = exports.ExerciseStatus = void 0;
var propTypes = require("prop-types");
var ExerciseStatus;
(function (ExerciseStatus) {
    ExerciseStatus["BUSY"] = "BUSY";
    ExerciseStatus["BROKEN"] = "BROKEN";
    ExerciseStatus["READY"] = "READY";
    ExerciseStatus["NONE"] = "NONE";
})(ExerciseStatus = exports.ExerciseStatus || (exports.ExerciseStatus = {}));
var ExerciseEnvironment;
(function (ExerciseEnvironment) {
    ExerciseEnvironment["PRODUCTION"] = "PRODUCTION";
    ExerciseEnvironment["STAGING"] = "STAGING";
    ExerciseEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExerciseEnvironment["LOCAL"] = "LOCAL";
    ExerciseEnvironment["TEST"] = "TEST";
})(ExerciseEnvironment = exports.ExerciseEnvironment || (exports.ExerciseEnvironment = {}));
var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes["VIDEO"] = "VIDEO";
    ResourceTypes["SLIDES"] = "SLIDES";
})(ResourceTypes = exports.ResourceTypes || (exports.ResourceTypes = {}));
exports.exercisePropTypes = {
    environment: propTypes.oneOf(Object.keys(ExerciseEnvironment)).isRequired,
    id: propTypes.number,
    isActive: propTypes.bool.isRequired,
    nextIds: propTypes.arrayOf(propTypes.number.isRequired).isRequired,
    resources: propTypes.arrayOf(propTypes.shape({
        data: propTypes.object.isRequired,
        type: propTypes.oneOf(Object.keys(ResourceTypes)).isRequired,
    })),
    user: propTypes.shape({
        authenticationToken: propTypes.string.isRequired,
        email: propTypes.string.isRequired,
        hasActiveSubscription: propTypes.bool.isRequired,
        id: propTypes.number,
        isLoggedIn: propTypes.bool.isRequired,
        language: propTypes.string,
    }),
};
exports.campusCallbacksPropTypes = {
    onClientIsReady: propTypes.func.isRequired,
    onExerciseFinished: propTypes.func.isRequired,
    onExerciseIsReady: propTypes.func.isRequired,
    onExerciseStatusUpdate: propTypes.func.isRequired,
    onExerciseSubmitted: propTypes.func.isRequired,
    onXpUpdated: propTypes.func.isRequired,
};
exports.exerciseCallbacksPropTypes = {
    setExerciseProps: propTypes.func.isRequired,
};
//# sourceMappingURL=IExerciseContract.js.map